import style from './ProgressLine.module.css'
const ProgressLine = () => {
  return (
    <span className={style.loader}></span>
  );
};

export default ProgressLine;